export default "__VITE_ASSET__D2b8Jrxf__"